export default {
  'to-manager:btn': 'Вернуться в Мой Банк'
}
